import { PayloadAction } from '@reduxjs/toolkit'
import { getAgentMetrics } from '@http/agentMetricsService'
import { selectCredentials } from '@views/loginView/state/loginSlice'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { LoadAgentMetricsPayload } from '../types'
import { agentMetricsFailed, agentMetricsLoaded, filtersKey, loadAgentMetrics } from './agentMetricsSlice'

const message = (error: Error) => error.message || 'No fue posible cargar las métricas.'

function* loadHttp(action: PayloadAction<LoadAgentMetricsPayload>) {
  const requestKey = filtersKey(action.payload)
  const { cocap } = yield select(selectCredentials)
  try {
    const data = yield call(getAgentMetrics, cocap, action.payload)
    yield put(agentMetricsLoaded({ requestKey, data }))
  } catch (error) {
    yield put(agentMetricsFailed({ requestKey, message: message(error) }))
  }
}

export default function* agentMetricsSaga() {
  yield takeLatest(loadAgentMetrics.type, loadHttp)
}
